/**
 * «Tus compañeros» (GEN-PX-012, spec §4.7, HU-13). Mockup A-despacho-entrada.html
 * (.fila .p con .av.hu): píldoras con círculo gris de iniciales (decisión de Jose, 22/10: sin foto),
 * nombre y, debajo, el cargo; si el directorio no lo tiene, el rol traducido.
 *
 * Los datos salen de GET /v1/entrada/empleados (cualquier usuario del tenant; solo activos y sin
 * email). Sin datos —o si el kernel no deja verlos— la sección no se pinta. Con más de 8, las 8
 * primeras por nombre (aún no hay actividad por usuario) y el enlace a Personas (vista `personas`, GEN-PX-022). «Invitar» solo si el
 * menú del kernel da Administración (el kernel revalida). Sin punto de conexión: llega con GEN-PX-E10.
 * Pulsar una persona lleva a su perfil, en solo lectura (GEN-PX-006, ampliación 2026-10-27); antes abría
 * una ficha mínima en un tooltip. Tamaño: el doble que la primera versión (tokens --dk-persona-*).
 */

import { Avatar, Insignia, Tarjeta } from '../ui.jsx'
import useEmpleados from './useEmpleados.js'
import { inicialesDe, subtituloDe, visiblesDe } from '../../lib/empleados.js'

function Persona({ e, onVerPerfil }) {
  return (
    <button type="button" className="dk-persona" onClick={() => onVerPerfil?.(e)}>
      <Avatar iniciales={inicialesDe(e.nombre)} nombre={e.nombre} tamano={56} />
      <span className="dk-persona__txt">
        <span className="dk-persona__nombre">{e.nombre}</span>
        <small className="dk-persona__sub">{subtituloDe(e)}</small>
      </span>
    </button>
  )
}

export default function Empleados({ onInvitar, onVerPersonas, onVerPerfil }) {
  const empleados = useEmpleados()
  if (!empleados) return null
  const { visibles, todas } = visiblesDe(empleados)
  if (todas === 0) return null

  return (
    <section className="dk-empleados" aria-label="Tus compañeros">
      <div className="dk-empleados__cab">
        <h2 className="dk-empleados__titulo">Tus compañeros</h2>
        <Insignia>{todas}</Insignia>
        {todas > visibles.length && onVerPersonas && (
          <button type="button" className="dk-empleados__enlace" onClick={onVerPersonas}>Ver todo el equipo</button>
        )}
        {onInvitar && <button type="button" className="dk-empleados__enlace" onClick={onInvitar}>Invitar</button>}
      </div>
      <Tarjeta className="dk-empleados__fila">
        {visibles.map((e, i) => (
          <Persona key={`${e.nombre}-${i}`} e={e} onVerPerfil={onVerPerfil} />
        ))}
      </Tarjeta>
    </section>
  )
}
